<template>
    <div class="not-found">
      <h1 class="txt-white">Ain't Nobody Here But Us Chickens</h1>
      <p class="txt-white">Unrecognized search pattern. Please try
         searching for a transaction by entering a block height,
         address, block hash or transaction hash.</p>
      <search>
        <div class="home-search-container" slot-scope="{ search_form, searchId, onInput }">
          <div class="blockSearch__body">
              <div class="blockSearch__form" id="overviewSearchForm">
                  <input :value="search_form"
                         @input="onInput"
                         @keyup.enter="searchId"
                         class="blockSearch__input" type="text" id="overviewSearchInput"
                         placeholder="Height / address / block hash / transaction hash"
                         autofocus="" required="">
                  <button @click="searchId"
                          class="blockSearch__button"
                          type="submit" value="Search"
                          id="searchButton">
                      <img class="blockSearch__icon hidden-sm-up" src="../assets/img/search.png" alt="Search">
                      <span class="hidden-xs-down">Search</span>
                  </button>
              </div>
          </div>
        </div>
      </search>
    </div>
</template>

<script>
import Search from './base/Search'

export default {
  name: 'NotFound',

  components: { Search }
}
</script>



// WEBPACK FOOTER //
// src/components/NotFound.vue